<template>
  <div class="all-wrap">
    <div class="tabs">
      <div v-for="item in tabList"
           :key="item.key"
           :class="'s2b-tab-item '+(item.key===activited?'tab-item-active':'')"
           @click="changeStatusHandle(item.key)">
        {{item.lable}}
      </div>
    </div>
    <!-- 我的回答列表 -->
    <div class="question-title" v-show="activited === 'myAsk'">
      <ul v-if="dataList&&dataList.length">
        <li v-for="data in dataList" :key="data.id">
          <!-- 头像 -->
          <div class="person">
            <img :src="data.userAvatarURL" />
            <!-- <p>孟冉</p> -->
          </div>
          <!-- 右侧内容 -->
          <div class="question-con">
            <div class="question-left">
              <h3 @click="handleAsk(data.id)">{{data.questionTitle}}</h3>
              <p class="question-latest">
                <span v-if="data.bestContent" class="new-answer">[最佳回答]</span>
                <span v-else class="new-answer">[最新回答]</span>
                <span>{{data.questionContent}}</span>
              </p>
              <div class="question-time">
                <span>{{data.createTime}}</span>
                <span class="question-label" v-for="item in data.attributeList" :key="item">{{item}}</span>
              </div>
            </div>
            <div class="question-right">
              <div class="answer-number">
                <span>回答数</span>
                <span>{{data.replyCount}}</span>
              </div>
              <div class="right-number">
                <span>点赞数</span>
                <span>{{data.praiseCount}}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-else>
        <div style="text-align:center">
          <img src="@/assets/img/good/noGood.png" alt="暂无数据">
        </div>
      </div>
    </div>
    <!-- 我的提問列表 -->
    <div class="question-title" v-show="activited !== 'myAsk'">
      <ul v-if="dataList&&dataList.length">
          <li v-for="data in dataList" :key="data.id">
              <!-- 头像 -->
              <div class="person">
                  <img :src="data.userAvatarURL" />
                  <!-- <p>孟冉</p> -->
              </div>
              <!-- 右侧内容 -->
              <div class="question-con">
                  <div class="question-left">
                      <h3 @click="handleAsk(data.id)">{{data.questionTitle}}</h3>
                      <p class="question-latest">
                          <span v-if="data.bestContent">[最佳回答]</span>
                          <span v-else>[最新回答]</span>
                          <span class="newContent">{{data.newContent}}</span>
                      </p>
                      <div class="question-time">
                          <span>{{data.createTime}}</span>
                          <span class="question-label" v-for="item in data.attributeList" :key="item">{{item}}</span>
                      </div>
                  </div>
                  <div class="question-right">
                      <div class="answer-number">
                          <span>回答数</span>
                          <span>{{data.replyCount}}</span>
                      </div>
                      <div class="right-number">
                          <span>点赞数</span>
                          <span>{{data.praiseCount}}</span>
                      </div>
                  </div>
              </div>
          </li>
      </ul>
      <div v-else>
        <div style="text-align:center">
          <img src="@/assets/img/good/noGood.png" alt="暂无数据">
        </div>
      </div>
    </div>
        <!-- 分页 -->
    <el-pagination background
    style="margin-top:10px;text-align: center;"
      layout="prev, pager, next, total, jumper, slot"
      prev-text="上一页"
      next-text="下一页"
      @current-change="getDataList"
      :current-page="currentPage" :page-size="10" :pager-count="5"
       :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      dataList: [],
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      activited: 'myQuestion',
      tabList: [
        {
          key: 'myQuestion',
          lable: '我的提问'
        },
        {
          key: 'myAsk',
          lable: '我的回答'
        }
      ]
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    changeStatusHandle (valueKey) {
      if (this.dataLoading) {
        return false
      }
      if (valueKey === this.activited) {
        return false
      }
      this.activited = valueKey
      this.getDataList(1)
    },
    // handleSizeChange (val) {
    //   this.getDataList(1)
    // },
    // 获取列表信息
    getDataList (page = this.currentPage) {
      this.currentPage = page
      this.$http.post(`/front/train/trainQuestionAnswer/${this.activited === 'myQuestion' ? 'listAtFrontGround' : 'listMyAnswersAtFrontGround'}`,
        {
          'page': this.currentPage,
          'limit': 10
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.dataList = data.data.data
            // this.totalPage = data.data.data.count
            // 分页
            this.total = Number(data.data.count) || 0
          }
        })
      this.jumpTargetPage = 1
    },
    // 跳转到贴吧
    handleAsk (id) {
      this.$router.push({ name: 'questionInfo', query: { id: id } })
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped lang="scss">
.all-wrap{
    width:100%;
    height: auto;
}
.question-title{
  overflow: hidden;
    width:820px;
    height:auto;
    margin-bottom:20px;
    background:#fff;
    margin: 0 69px;

}
.question-title ul li{
    height:128px;
    width:100%;
    border-bottom:1px solid #ccc;
    padding-top:10px;
}
.person{
    float:left;
    width:100px;
    height:85px;
    text-align: center;
    margin-right:30px;
}
.person img{
     width:60px;
    height:60px;
    border-radius: 50%;
    margin-bottom:10px;
}
.person p {
    width:100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.question-con{
    height:120px;
    float:left;
    width:690px;
}
.question-left{
    width:500px;
    float:left;
}
.question-left h3{
    height: 30px;
    line-height: 30px;
    font-weight: 600;
    color:#333;
    margin-bottom:15px;
    cursor: pointer;
    width:500px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}
.question-left h3:hover{
  color:#1d65a8
}
// 回答数浏览数
.question-right{
    float:right;
    width:160px;
    height:120px;
    text-align: center;
}
.answer-number{
    float:left;
    width:80px;
    height:50px;
    margin-top:75px;
}
.right-number{
    float:left;
    width:80px;
    height:50px;
    margin-top:75px;
}
.myAsk{
    width:60px;
    text-align: center;
}
.question-time{
    margin-top:10px;
    color:#999;
}
.question-label{
    padding:5px;
    background:#f5f5f5;
    color:#999;
    margin-right:5px;
}
.question-latest{
    width:500px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.page{
    margin-top:40px;
}
.new-answer{
    color:#1d65a8
}
</style>
